import React from "react";
import parse from "html-react-parser";

export default function ServicesSection({ sectionTitle, sectionTitleUp, data }) {
  return (
    <section className="cs_about_new_services">
      <div className="container">
        <div className="text-center cs_services_header">
          {sectionTitleUp && <h6 className="cs_section_subtitle">{sectionTitleUp}</h6>}
          {sectionTitle && <h2>{parse(sectionTitle)}</h2>}
        </div>
        
        <div className="cs_services_grid">
          {data?.map((item, index) => (
            <div className="cs_service_card" key={index}>
              {item.iconUrl && (
                <div className="cs_service_icon">
                  <img src={item.iconUrl} alt="Service Icon" />
                </div>
              )}
              <h3 className="cs_service_title">
                {item.title}
              </h3>
              <p className="cs_service_desc">{item.subTitle}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
